import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFeedbackChatbotModalActionTypes {
  Open = 'feedbackChatbotModal/show',
  Close = 'feedbackChatbotModal/hide',
  SetRating = 'feedbackChatbotModal/setRating',
  SetComment = 'feedbackChatbotModal/setComment',
  Reset = 'feedbackChatbotModal/Reset',
}

export type TFeedbackChatbotModalActions =
  | ITypedReduxAction<EFeedbackChatbotModalActionTypes.Open, void>
  | ITypedReduxAction<EFeedbackChatbotModalActionTypes.Close, void>
  | ITypedReduxAction<EFeedbackChatbotModalActionTypes.SetRating, number>
  | ITypedReduxAction<EFeedbackChatbotModalActionTypes.SetComment, string>
  | ITypedReduxAction<EFeedbackChatbotModalActionTypes.Reset, void>;
